<div class="relative app-modal">
  <!--<div class="absolute top-56 mx-6 bg-white rounded-3xl shadow-lg w-80 app-modal-body pulzo-left-40">-->
  <div class="absolute top-56 mx-6 bg-white rounded-3xl shadow-lg md:left-64 2xl:left-96">
    <ng-content></ng-content>
  </div>
</div>
<div class="app-modal-background"></div>
